<br>
<br>

<div style="text-align: center;">
    <div style="margin-bottom: 2%;margin-top: 1%;">

        <div style="text-align: center;">
            <h2 style="color: #333333; text-justify: auto;"> Video corsi gratuiti</h2>
        </div>

        <div class="card-container" style="padding: 0!important; margin-left: 3%; margin-right: 3%;">
            <div class="cards tags marg " *ngFor="let item of listObiettivi; let i = index" [ngClass]="{'ok' : selectedValue==item.text, 'no': selectedValue!=item.text}" style="text-align: center;">
                <div style="" class="boxCard" (click)="setTip(item.text, i)">

                    <i *ngIf="selectedValue===item.text" class="fa fa-check okIco"></i>


                    <label [ngClass]="{'ok' : selectedValue==item.text, 'no': selectedValue!=item.text}" style="text-align: center;"> {{item.text}} </label>
                </div>

            </div>

        </div>



        <br>
        <hr class="new1">
        <div *ngIf="showAll">
            <div *ngIf="!hideFit" style="margin-top: 3%; text-align: left;">

                <div class="categorie"> <label style="font-size: 20px; margin-left: 2%;"> Fitness</label></div>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo | tip: obiettivo">
                        <app-card *ngIf="item.categoria === 'Fitness'" [path]="item.imagePath" [title]="item.title" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                      <div class="card marg">
                          <label style="margin-top: 20%;">  Vedi tutti i corsi
                        <i class="fa fa-arrow-right fa-2x"></i>
                       </label>
                      </div>

                  </div>-->
                </div>
            </div>

            <div *ngIf="!hidePil" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Pilates</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo | tip: obiettivo">
                        <app-card *ngIf="item.categoria === 'Pilates'" [path]="item.imagePath" [title]="item.title" [id]="item.id" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                      <div class="card marg">
                          <label style="margin-top: 20%;">  Vedi tutti i corsi
                        <i class="fa fa-arrow-right fa-2x"></i>
                       </label>
                      </div>

                  </div>-->
                </div>
            </div>

            <div *ngIf="!hideGinn" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Ginnastica Dolce</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo | tip: obiettivo">
                        <app-card *ngIf="item.categoria === 'Ginnastica dolce'" [path]="item.imagePath" [title]="item.title" [id]="item.id" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                      <div class="card marg">
                          <label style="margin-top: 20%;">  Vedi tutti i corsi
                        <i class="fa fa-arrow-right fa-2x"></i>
                       </label>
                      </div>

                  </div>-->
                </div>
            </div>

            <div *ngIf="!hidePost" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Posturale</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo | tip: obiettivo">
                        <app-card *ngIf="item.categoria === 'Posturale'" [path]="item.imagePath" [title]="item.title" [id]="item.id" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                      <div class="card marg">
                          <label style="margin-top: 20%;">  Vedi tutti i corsi
                        <i class="fa fa-arrow-right fa-2x"></i>
                       </label>
                      </div>

                  </div>-->
                </div>
            </div>

            <div *ngIf="!hideAnz" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Anziani</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo | tip: obiettivo">
                        <app-card *ngIf="item.categoria === 'Anziani'" [path]="item.imagePath" [title]="item.title" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                      <div class="card marg">
                          <label style="margin-top: 20%;">  Vedi tutti i corsi
                        <i class="fa fa-arrow-right fa-2x"></i>
                       </label>
                      </div>

                  </div>-->
                </div>
            </div>

            <div *ngIf="!hideBamb" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Bambini</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo | tip: obiettivo">
                        <app-card *ngIf="item.categoria === 'Bambini'" [path]="item.imagePath" [title]="item.title" [id]="item.id" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                      <div class="card marg">
                          <label style="margin-top: 20%;">  Vedi tutti i corsi
                        <i class="fa fa-arrow-right fa-2x"></i>
                       </label>
                      </div>

                  </div>-->
                </div>
            </div>

            <div *ngIf="!hidePat" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Patologie</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo | tip: obiettivo">
                        <app-card *ngIf="item.categoria === 'Patologie'" [path]="item.imagePath" [title]="item.title" [id]="item.id" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>


                    </div>



                    <!--  <div style="text-align: center;width: 300px;">
                      <div class="card marg">
                          <label style="margin-top: 20%;">  Vedi tutti i corsi
                        <i class="fa fa-arrow-right fa-2x"></i>
                       </label>
                      </div>

                  </div>-->

                </div>
            </div>
        </div>

        <div *ngIf="!showAll">
            <div *ngIf="!hideFit" style="margin-top: 3%; text-align: left;">

                <div class="categorie"> <label style="font-size: 20px; margin-left: 2%;"> Fitness</label></div>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo">
                        <app-card *ngIf="item.categoria === 'Fitness'" [path]="item.imagePath" [title]="item.title" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                  <div class="card marg">
                      <label style="margin-top: 20%;">  Vedi tutti i corsi
                    <i class="fa fa-arrow-right fa-2x"></i>
                   </label>
                  </div>

              </div>-->
                </div>
            </div>

            <div *ngIf="!hidePil" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Pilates</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo ">
                        <app-card *ngIf="item.categoria === 'Pilates'" [path]="item.imagePath" [title]="item.title" [id]="item.id" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                  <div class="card marg">
                      <label style="margin-top: 20%;">  Vedi tutti i corsi
                    <i class="fa fa-arrow-right fa-2x"></i>
                   </label>
                  </div>

              </div>-->
                </div>
            </div>

            <div *ngIf="!hideGinn" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Ginnastica Dolce</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo ">
                        <app-card *ngIf="item.categoria === 'Ginnastica dolce'" [path]="item.imagePath" [title]="item.title" [id]="item.id" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                  <div class="card marg">
                      <label style="margin-top: 20%;">  Vedi tutti i corsi
                    <i class="fa fa-arrow-right fa-2x"></i>
                   </label>
                  </div>

              </div>-->
                </div>
            </div>

            <div *ngIf="!hidePost" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Posturale</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo ">
                        <app-card *ngIf="item.categoria === 'Posturale'" [path]="item.imagePath" [title]="item.title" [id]="item.id" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                  <div class="card marg">
                      <label style="margin-top: 20%;">  Vedi tutti i corsi
                    <i class="fa fa-arrow-right fa-2x"></i>
                   </label>
                  </div>

              </div>-->
                </div>
            </div>

            <div *ngIf="!hideAnz" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Anziani</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo ">
                        <app-card *ngIf="item.categoria === 'Anziani'" [path]="item.imagePath" [title]="item.title" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                  <div class="card marg">
                      <label style="margin-top: 20%;">  Vedi tutti i corsi
                    <i class="fa fa-arrow-right fa-2x"></i>
                   </label>
                  </div>

              </div>-->
                </div>
            </div>

            <div *ngIf="!hideBamb" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Bambini</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo ">
                        <app-card *ngIf="item.categoria === 'Bambini'" [path]="item.imagePath" [title]="item.title" [id]="item.id" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>

                    </div>
                    <!--  <div style="text-align: center;width: 300px;">
                  <div class="card marg">
                      <label style="margin-top: 20%;">  Vedi tutti i corsi
                    <i class="fa fa-arrow-right fa-2x"></i>
                   </label>
                  </div>

              </div>-->
                </div>
            </div>

            <div *ngIf="!hidePat" style="margin-top: 3%; text-align: left;">
                <label style="font-size: 20px; margin-left: 2%;">Patologie</label>
                <div class="card-container ">
                    <div *ngFor="let item of listVideo ">
                        <app-card *ngIf="item.categoria === 'Patologie'" [path]="item.imagePath" [title]="item.title" [id]="item.id" [routerLink]="['/patdifairplay/dettaglioVideo/', item.id]"></app-card>


                    </div>



                    <!--  <div style="text-align: center;width: 300px;">
                  <div class="card marg">
                      <label style="margin-top: 20%;">  Vedi tutti i corsi
                    <i class="fa fa-arrow-right fa-2x"></i>
                   </label>
                  </div>

              </div>-->

                </div>
            </div>
        </div>




    </div>
</div>
